import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import {
	Button,
	Label,
	Card,
	Checkbox,
	// Grid,
	Input,
	Rating,
} from "semantic-ui-react";
import {
	ErrorMessage,
	Form,
	Field,
	// FieldArray,
	Formik,
	useField,
} from "formik";

import * as Yup from "yup";
import agent from "../../api/agent";
import {
	ModalWithContextProvider,
	useModalWithContext,
} from "../../layouts/ModalWithContext";
import feedbackdata, { feedbackCsvHeaders } from "../../shared/FeedbackData";
import { COMPANY_EMAIL } from "../../shared/Literals";
import { useAuth } from "../../providers/AuthProvider";


export const TextInputField = ({
	field: name,
	...props
}: {
	field: any;
	name: string;
}) => {
	const [field, meta, helpers] = useField(name);

	return (
		<>
			<Input
				labelPosition="left"
				{...field}
				{...props}
				type={"text"}
				value={field.value ? field.value : field.value === 0 ? "0" : ""}>
				<textarea {...field} rows={4} cols={50} />
			</Input>
			{meta.touched && meta.error ? (
				<Label
					basic
					color="red"
					size="tiny"
					style={{ padding: "0px", border: "none", display: "block" }}>
					{meta.error}
				</Label>
			) : null}
		</>
	);
};



export const UserProfileCompletionConsentForm = ({
	formDispatcher,
}: {
	formDispatcher: Function | undefined;
}) => {
	//use a separate dispacher for the modal that will show upon success or failure of feedback submission.
	//This way, the feedback form will not be affected by the closing of the that modal, since it has a different dispatch, formDispatcher
	const { modalDispatcher } = useModalWithContext();
	const { user } = useAuth();

	const closeModal = () => {
		formDispatcher && formDispatcher({ open: false });
	};

	const [isLoading, setIsLoading] = React.useState<boolean>(false);
	const [submitSuccess, setSubmitSuccess] = React.useState<any>(false);
	const history = useHistory();

	useEffect(() => {
		if (submitSuccess) {
			const thankMsg =
				"We will contact you soon. A copy of your request has been sent to your email.\n\n" ;

			formDispatcher &&
				formDispatcher({
					open: true,
					size: "tiny",
					displayType: "info",
					options: {
						title: "Thank you",
						body: thankMsg,
						basicModal: true,
					},
				});
		}
	}, [submitSuccess]);

	// const [validateSchema, setValidateSchema] = React.useState<any>(
	// 	Yup.object({
	// 		reasonForRequest: Yup.string().optional(),
	// 	})
	// );


	const handleClick = () => {
		history.push("/userprofile");
	};

	const handleFormSubmit: Function = async (
		values: any,
		setErrors: Function
	) => {
		// console.log(values);
		// const msg = messageBody(values);
		try {
			setIsLoading(true);

		} catch (error: any) {
			setSubmitSuccess(false);
			modalDispatcher &&
				modalDispatcher({
					open: true,
					size: "tiny",
					displayType: "error",
					options: {
						title: "Something happened...",
						body: `There was a problem directing you to the profile page. \nPlease try again or contact the ESVD Team at ${COMPANY_EMAIL}`,
						basicModal: true,
					},
				});
			setIsLoading(false);
		}
	};

	// const messageBody = (frmData: any) => {
	// 	//
	// 	let msg = `<div style={{ marginBlockStart: "0em", padding: "0em 2.5em", marginBottom:"1em" }}>
	// 					Dear ${user?.displayName ? user.displayName : user?.userName},
	// 					<br />
				
	// 	</div>
	// 	<ul>
	// 		<li>${"Reason for your request (optional)"}<br/><br/>
	// 		<br/>
	// 		${frmData["reasonForRequest"] || ""}<br/><br/><br/>
	// 		</li>		
	// 	</ul>		
	// 	`;

	// 	return msg;
	// };

	return (
		<Card.Content style={{ overflowY: "auto", height: "100%" }}>
			<Formik
				enableReinitialize={true}
				initialValues={{
					error: null,
					// reasonForRequest: "",
				}}
				// validationSchema={validateSchema}
				onSubmit={(values, { setErrors }) => {
					handleFormSubmit(values, setErrors);
				}}
				>
				{({ handleSubmit, errors }) => (
					<Form onSubmit={handleSubmit} className="custom-ui-element">
						<div
							style={{
								marginBlockStart: "0em",
								padding: "0em 2.5em",
								marginBottom: "1em",
							}}>
							Dear {user?.displayName ? user.displayName : user?.userName},
							<br />
						</div>

						<ul style={{ listStyle: 'none'}}>
							<li className="feedback-list">
								<div
									dangerouslySetInnerHTML={{
										__html: ` ${
											"<strong>Before you can submit your request, we kindly ask you to complete your user profile first. The \"Complete Profile\" button will take you to your current user profile page. When completed and saved, you can continue the request process by clicking the \"Get full ESVD as CSV\" button on the Database page again.</strong>"}`,
									}}
								/>
							</li>

		
						</ul>
						<br />
						<Button
							className="btn btn-feedback btn-warning"
							floated="left"
							style={{
								marginLeft: "2.5em",
								minWidth: "4em",
								backgroundColor: "#f6da6e",
							}}
							onClick={closeModal}>
							Close
						</Button>
						<Button
							className="btn btn-feedback btn-primary"
							type="submit"
							// primary
							floated="right"
							loading={isLoading}
							onClick={handleClick}
							style={{
								backgroundColor: "#70bbfd",
								marginRight: "2.5em",
								minWidth: "4em",
							}}>
							Complete Profile
						</Button>
						<ErrorMessage
							name="error"
							render={() => (
								<Label
									style={{ marginBottom: 5, borderColor: "none" }}
									basic
									color="red"
									size="tiny"
									content={errors.error}
								/>
							)}
						/>
					</Form>
				)}
			</Formik>
		</Card.Content>
	);
};

const UserProfileCompletionConsentFormWrapper = ({
	formDispatcher,
}: {
	formDispatcher: Function | undefined;
}) => {
	return (
		<ModalWithContextProvider>
			<UserProfileCompletionConsentForm formDispatcher={formDispatcher} />
		</ModalWithContextProvider>
	);
};

export default UserProfileCompletionConsentFormWrapper;
